// Ring 0 — pure URL `?seed=` parser (D-EM-03 dual-form: decimal + base36).
//
// Hosted in src/run/ (Phaser-free) so it can be unit-tested without booting
// the engine. BootScene re-exports it for the boot path.
//
// Phase-2 share URLs emit `?seed=<base36>` (lower-32-bits, max 8 chars from
// encodeSeedShort). Phase-1 E2E and discord-shared decimal seeds keep working
// via the strict decimal recognizer — the digits-only guard prevents
// `parseInt('42', 36) === 146` from hijacking pure-decimal inputs.
//
// Falls back to seed=1 for null / empty / non-base36 input so the boot
// sequence never crashes (T-02-01 ASVS L1: input validation).
//
// NO Phaser imports. NO Math.random. (CLAUDE.md anti-patterns.)

export function parseSeedParam(raw: string | null): number {
  if (raw === null || raw === '') return 1;
  // Strict decimal first — preserves Phase-1 behavior for ?seed=42.
  if (/^-?\d+$/.test(raw)) {
    const decimal = Number(raw);
    if (Number.isFinite(decimal)) return decimal;
  }
  // Fall back to base36 — but ONLY if the WHOLE string is base36 chars.
  // Without the all-base36 guard, `parseInt('not-a-seed!', 36)` parses the
  // 'n-o-t' prefix and silently returns 30701 — the parser's contract says
  // unparseable input must default to seed=1.
  if (/^[0-9a-zA-Z]+$/.test(raw)) {
    const base36 = parseInt(raw, 36);
    if (Number.isFinite(base36) && !Number.isNaN(base36)) return base36;
  }
  return 1;
}
